/**
 * Deterministic jagged "tear" polygon points for the stub-bottom and body-top
 * overlays. The two shapes use a shared seed and complementary y formulas so
 * the teeth interlock — when both edges are visible side-by-side (briefly, at
 * the start of the tear) they look like the same rip from both sides.
 *
 * Polygons are emitted in a normalised 0..100 viewBox; the SVG callers use
 * preserveAspectRatio="none" so the polygons stretch to any ticket width.
 */

const TEAR_SEED = [
  4, 1, 6, 2, 5, 1, 4, 7, 3, 5, 2, 6, 1, 4, 3, 6, 2, 5, 4, 1, 5, 3, 6, 2, 4, 1, 5, 3,
];

const SEED_MAX = 8;
const VIEWBOX = 100;

/**
 * Polygon for the overlay that sits at the **bottom** of the top stub.
 * Flat bottom edge + jagged top edge — so the stub appears to have a
 * torn-off bottom when the overlay is filled with the background colour.
 */
export function getStubTearPolygonPoints(): string {
  const pts: string[] = [`0,${VIEWBOX}`, `${VIEWBOX},${VIEWBOX}`];
  for (let i = TEAR_SEED.length - 1; i >= 0; i--) {
    const x = (i / (TEAR_SEED.length - 1)) * VIEWBOX;
    const y = VIEWBOX - (TEAR_SEED[i] / SEED_MAX) * VIEWBOX;
    pts.push(`${x.toFixed(2)},${y.toFixed(2)}`);
  }
  return pts.join(' ');
}

/**
 * Polygon for the overlay that sits at the **top** of the body. Flat top edge
 * + jagged bottom edge — body looks like it was torn from above.
 */
export function getBodyTearPolygonPoints(): string {
  const pts: string[] = [`0,0`, `${VIEWBOX},0`];
  for (let i = TEAR_SEED.length - 1; i >= 0; i--) {
    const x = (i / (TEAR_SEED.length - 1)) * VIEWBOX;
    const y = (TEAR_SEED[i] / SEED_MAX) * VIEWBOX;
    pts.push(`${x.toFixed(2)},${y.toFixed(2)}`);
  }
  return pts.join(' ');
}

export const TEAR_EDGE_PX = 12;
